import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './possessives-explanation';

const mainimage = '/Images/possessives.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice possessive adjectives and pronouns.", type: "quiz", subtype: "possessives" },
];

const Possessives = () => (
  <GrammarPageLayout
    level="A1"
    title="Possessive Adjectives & Pronouns (my, mine)"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Possessive Adjectives and Pronouns Exercises"
    seoDescription="Practice possessive adjectives (my, your, his, her) and possessive pronouns (mine, yours, his, hers). A1 level grammar exercises."
    relatedCategory="grammar-exercises"
    relatedLevel="A1"
  />
);

export default Possessives;